/**
 * ReviCoCookie周りの処理のUtil。
 */
export default class ReviCoCookieUtil {
	/**
	 * ReviCoCookieIdのクッキー名。
	 */
	private static revicoCookieName = "revico-visitor-id";

	/**
	 * ReviCoCookieIdを取得する。
	 * @returns 取得結果(取得できなかった場合は`undefined`が返却)
	 */
	public static getReviCoCookieId(): string | undefined {
		// Cookieが存在しない場合取得不可
		if (document.cookie.length === 0) {
			return undefined;
		}

		// ReviCoCookieIdのクッキー名に合致するCookieが存在しない場合取得不可
		let c_start = document.cookie.indexOf(this.revicoCookieName + "=");
		if (c_start === -1) {
			return undefined;
		}

		c_start = c_start + this.revicoCookieName.length + 1;
		let c_end = document.cookie.indexOf(";", c_start);
		if (c_end === -1) {
			c_end = document.cookie.length;
		}
		return decodeURI(document.cookie.substring(c_start, c_end));
	}
}
